import type { ScaleLinear } from 'd3-scale';

const barMargin = 6;
const barWidth = 12;

export const gaugeRadius = 120;
export const max: number = 0.5 * Math.PI;
export const stop: number = 0.7 * Math.PI;

export const getSegments = (): number[] =>
  Array.from({ length: 181 }, (n, i) => (i - 90) * (Math.PI / 180)).filter(
    (n, i, a) => (i !== a.length - 1 ? !(i % 2) : true)
  );

export const getRingRadius = (position: string, level = 0): number => {
  if (position === 'outer') {
    return gaugeRadius - barWidth * level - (level > 0 ? barMargin * level : 0);
  }
  return gaugeRadius - barWidth * level - barMargin * level - barWidth;
};

export const getEndAngle = (
  xScale: ScaleLinear<number, number>,
  value: number
): number => {
  const max = xScale.invert(stop);
  const min = xScale.invert(-stop);
  if (value > max) {
    return stop;
  } else if (value < min) {
    return -stop;
  }
  return xScale(value) || 0;
};
